import classNames from "classnames";
import React, { forwardRef } from "react";
import type { Swiper as SwiperType } from "swiper";
import { useSlides } from "./helpers/useSlideHelper";
type MobileConfiguratorProgressBarProps = {
  activeIndex: number;
};
export const MobileConfiguratorProgressBarBottom = forwardRef<
  SwiperType | null,
  MobileConfiguratorProgressBarProps
>(({ activeIndex }, ref) => {
  const swiperRef = ref as React.RefObject<SwiperType>;
  const { slides } = useSlides();
  return (
    <div className="gg-relative gg-z-50 gg-flex gg-items-center gg-justify-center">
      {slides.map((slide, index) => {
        const isActive = index === activeIndex;
        return (
          <button
            key={slide.name}
            type="button"
            aria-label={`Ga naar ${slide.name}`}
            aria-current={isActive ? "step" : undefined}
            onClick={() => swiperRef.current?.slideTo(index)}
            className="gg-grid gg-h-11 gg-w-11 gg-place-items-center gg-rounded-full"
          >
            <span
              aria-hidden="true"
              className={classNames("gg-h-2 gg-w-2 gg-rounded-full", {
                "gg-bg-dark-blue": isActive,
                "gg-bg-[#d7d7da]": !isActive,
              })}
            />
          </button>
        );
      })}
    </div>
  );
});
